<script setup lang="ts">
defineProps<{
  name: string
  id: string
}>()
</script>

<template>
  <GAList :id="id" :name="name" entity="modalCartProducts">
    <slot />
  </GAList>
</template>
